// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__ex_F5","card":"page_card__ZffAD","cardContainer":"page_cardContainer__VWuDv","typeSelectorContainer":"page_typeSelectorContainer__A3_9O"};